module.exports = __webpack_public_path__ + "img/banner-one7.1da202a9.png";